export default __webpack_public_path__ + "static/media/tutorial6-2.ea08e83e.png";